module.exports = __webpack_public_path__ + "static/img/class-room-masthead.c82ada7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/class-room-masthead.jpg
// module id = wF41
// module chunks = 1